<template>
  <v-dialog v-model="opened" :max-width="520">
    <v-card>
      <v-card-title>
        {{ $t('label.select_a_direction') }}
      </v-card-title>
      <v-list expand>
        <v-list-tile>
          <v-list-tile-content>
            <v-btn
              flat block
              :large="$i18n.locale !== 'en'"
              class="list-item-btn"
              @click="onClickDirection(1)"
            >
              <span>{{ $t('direction.for_sapporo') }}</span>
            </v-btn>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider />
        <v-list-tile>
          <v-list-tile-content>
            <v-btn
              flat large block
              class="list-item-btn"
              @click="onClickDirection(2)"
            >
              <span>{{ $t('direction.for_obihiro_kushiro') }}</span>
            </v-btn>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-card-actions>
        <v-spacer />
        <v-btn flat @click="opened = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ServiceStatusDialog',
  data () {
    return {
      opened: false
    }
  },
  methods: {
    open () {
      this.opened = true
    },
    onClickDirection (homeNo) {
      let fileName = `servicestatus_image_${homeNo}.png`
      this.$router.push({
        name: 'ImageView',
        params: { fileName }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item-btn {
  text-transform: none;
  margin-top: 0;
  margin-bottom: 0;
  span {
    white-space: normal;
  }
}
</style>

